import React, { useEffect, useState, forwardRef, useRef, useImperativeHandle } from 'react';
// import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import apiService from '../../Services/apiServices';
import AtkPurchaseBookHeader from '../../components/Reports/ReportATK/AtkPurchaseBookHeader';
import AtkSaleBookHeader from '../../components/Reports/ReportATK/AtkSaleBookHeader';
import XLSX from 'xlsx-js-style';

const getAtkSaleExportColumns = (reference) => ([
    { key: 'Nr', label: 'Nr', width: 5, type: 'text' },
    { key: 'Date', label: 'Data', width: 12, type: 'text' },
    { key: reference ? 'Reference' : 'InvoiceNo', label: reference ? 'Referenca' : 'Numri i faturës', width: 16, type: 'text' },
    { key: 'CompanyName', label: 'Emri i blerësit', width: 18, type: 'text' },
    { key: 'FiscalNumber', label: 'Numri fiskal i blerësit', width: 16, type: 'text' },
    { key: 'VatNumber', label: 'Numri i TVSH-se se blerësit', width: 16, type: 'text' },
    { key: 'K9', label: 'Shitjet e liruara pa të drejtë kreditimi', box: '9', width: 10, type: 'number' },
    { key: 'K10a', label: 'Shitjet e shërbimeve jashtë vendit', box: '10a', width: 10, type: 'number' },
    { key: 'K10b', label: 'Shitjet e brenda vendit me ngarkesë të kundërt të TVSH-të', box: '10b', width: 10, type: 'number' },
    { key: 'K10c', label: 'Shitjet e liruara me të drejtë kreditimi', box: '10c', width: 10, type: 'number' },
    { key: 'K10', label: 'Totali i shitjeve të liruara me të drejtë kreditimi', box: '10', width: 10, type: 'number' },
    { key: 'K11', label: 'Eksportet', box: '11', width: 10, type: 'number' },
    { key: 'K12', label: 'Shitjet e tatueshme me normën 18%', box: '12', width: 10, type: 'number' },
    { key: 'K16', label: 'debitore e lëshuar, nota kreditore', box: '16', width: 10, type: 'number' },
    { key: 'K20', label: 'borxhit të keq e pranuar, inkasimi I.B.K.', box: '20', width: 10, type: 'number' },
    { key: 'K24', label: 'met për të rritur TVSH-në me normë', box: '24', width: 10, type: 'number' },
    { key: 'K28', label: 'që i nënshtrohen ngarkesës së', box: '28', width: 10, type: 'number' },
    { key: 'K1', label: 'TVSH-se se zbritshme me 18%', box: '[K1]', width: 10, type: 'number' },
    { key: 'K14', label: 'Shitjet e tatueshme me normën 8%', box: '14', width: 10, type: 'number' },
    { key: 'K18', label: 'debitore e lëshuar, nota kreditore', box: '18', width: 10, type: 'number' },
    { key: 'K22', label: 'borxhit të keq e pranuar, inkasimi I.B.K.', box: '22', width: 10, type: 'number' },
    { key: 'K26', label: 'met për të rritur TVSH-në me normë', box: '26', width: 10, type: 'number' },
    { key: 'K2', label: 'TVSH-se se llogaritur me normën', box: '[K2]', width: 10, type: 'number' },
    { key: 'K30', label: 'Totali i TVSH-se se zbritshme me 18% dhe 8%', box: '[30]', width: 10, type: 'number' },
]);

const getAtkPurchaseExportColumns = () => ([
    { key: 'Pos', label: 'Nr', width: 5, type: 'text' },
    { key: 'Date', label: 'Data', width: 12, type: 'text' },
    { key: 'InvoiceNo', label: 'Numri i fatures', width: 14, type: 'text' },
    { key: 'CompanyName', label: 'Emri i Shitesit', width: 18, type: 'text' },
    { key: 'FiscalNumber', label: 'Numri fiskal i Shitesit', width: 16, type: 'text' },
    { key: 'VatNumber', label: 'Numri i TVSH-se se shitësit', width: 16, type: 'text' },
    { key: 'K31', label: 'Blerjet dhe importet pa TVSH', box: '31', width: 10, type: 'number' },
    { key: 'K32', label: 'Blerjet dhe importet investive pa TVSH', box: '32', width: 10, type: 'number' },
    { key: 'K33', label: 'Blerjet dhe importet me TVSH jo te zbritshme', box: '33', width: 10, type: 'number' },
    { key: 'K34', label: 'Blerjet dhe importet investive me TVSH jo te zbritshme', box: '34', width: 10, type: 'number' },
    { key: 'K35', label: 'Importet me norme 18%', box: '35', width: 10, type: 'number' },
    { key: 'K39', label: 'Importet investive me norme 18%', box: '39', width: 10, type: 'number' },
    { key: 'K43', label: 'Blerjet vendore me norme 18%', box: '43', width: 10, type: 'number' },
    { key: 'K47', label: 'Blerjet investive vendore me norme 18%', box: '47', width: 10, type: 'number' },
    { key: 'K53', label: 'debitore e pranuar, nota kreditore e leshuar', box: '53', width: 10, type: 'number' },
    { key: 'K57', label: 'borxhit te keq, pagesa e borxhit', box: '57', width: 10, type: 'number' },
    { key: 'K61', label: 'met per te ulur TVSH-ne me norme', box: '61', width: 10, type: 'number' },
    { key: 'K65', label: 'e kreditimit te TVSH-se ne', box: '65', width: 10, type: 'number' },
    { key: 'K1', label: 'TVSH-se se zbritshme me 18%', box: '[K1]', width: 10, type: 'number' },
    { key: 'K37', label: 'Importet me norme 8%', box: '37', width: 10, type: 'number' },
    { key: 'K41', label: 'Importet investive me norme 8%', box: '41', width: 10, type: 'number' },
    { key: 'K45', label: 'Blerjet vendore me norme 8%', box: '45', width: 10, type: 'number' },
    { key: 'K49', label: 'Blerjet investive vendore me norme 8%', box: '49', width: 10, type: 'number' },
    { key: 'K51', label: 'nga fermeret vendore me norme', box: '51', width: 10, type: 'number' },
    { key: 'K55', label: 'debitore e pranuar, nota kreditore', box: '55', width: 10, type: 'number' },
    { key: 'K59', label: 'borxhit te keq, pagesa', box: '59', width: 10, type: 'number' },
    { key: 'K63', label: 'met per te ulur TVSH-ne me norme', box: '63', width: 10, type: 'number' },
    { key: 'K2', label: 'TVSH-se se zbritshme me 8%', box: '[K2]', width: 10, type: 'number' },
    { key: 'K67', label: 'Totali i TVSH-se se zbritshme me 18% dhe 8%', box: '[67]', width: 10, type: 'number' },
]);

const atkSaleMerges = [
    { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
    { s: { r: 0, c: 1 }, e: { r: 0, c: 2 } },
    { s: { r: 0, c: 3 }, e: { r: 0, c: 5 } },
    { s: { r: 0, c: 6 }, e: { r: 0, c: 11 } },
    { s: { r: 0, c: 12 }, e: { r: 0, c: 17 } },
    { s: { r: 0, c: 18 }, e: { r: 0, c: 22 } },
    { s: { r: 0, c: 23 }, e: { r: 1, c: 23 } },
    { s: { r: 2, c: 0 }, e: { r: 2, c: 5 } },
];

const atkPurchaseMerges = [
    { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
    { s: { r: 0, c: 1 }, e: { r: 0, c: 2 } },
    { s: { r: 0, c: 3 }, e: { r: 0, c: 5 } },
    { s: { r: 0, c: 6 }, e: { r: 0, c: 9 } },
    { s: { r: 0, c: 10 }, e: { r: 0, c: 18 } },
    { s: { r: 0, c: 19 }, e: { r: 0, c: 27 } },
    { s: { r: 0, c: 28 }, e: { r: 1, c: 28 } },
    { s: { r: 2, c: 0 }, e: { r: 2, c: 5 } },
];

const atkSaleGroupRanges = [
    { start: 1, end: 2, label: 'Fatura' },
    { start: 3, end: 5, label: 'Blerësi' },
    { start: 6, end: 11, label: 'Shitjet e liruara nga TVSH' },
    { start: 12, end: 17, label: 'Shitjet e tatueshme me normën 18%' },
    { start: 18, end: 22, label: 'Shitjet e tatueshme me normën 8%' },
];

const atkPurchaseGroupRanges = [
    { start: 1, end: 2, label: 'Fatura' },
    { start: 3, end: 5, label: 'Shitesi' },
    { start: 6, end: 9, label: 'Blerjet dhe importet e liruara dhe me TVSH jo te zbritshme' },
    { start: 10, end: 18, label: 'Blerjet dhe importet e tatueshme me 18%, si dhe rregullimet e zbritjeve' },
    { start: 19, end: 27, label: 'Blerjet dhe importet e tatueshme me 8%, si dhe rregullimet e zbritjeve' },
];

const atkSaleNumberFormat = '#,##0.00';
const atkSaleBorder = {
    top: { style: 'thin', color: { rgb: '000000' } },
    bottom: { style: 'thin', color: { rgb: '000000' } },
    left: { style: 'thin', color: { rgb: '000000' } },
    right: { style: 'thin', color: { rgb: '000000' } }
};

const atkSaleStyles = {
    group: {
        font: { bold: true, sz: 11, name: 'Arial' },
        alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
        border: atkSaleBorder,
    },
    header: {
        font: { sz: 10, name: 'Arial' },
        alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
        border: atkSaleBorder,
    },
    headerGrey: {
        font: { sz: 10, name: 'Arial' },
        alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
        border: atkSaleBorder,
        fill: { fgColor: { rgb: 'D9D9D9' } },
    },
    headerGreen: {
        font: { sz: 10, name: 'Arial' },
        alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
        border: atkSaleBorder,
        fill: { fgColor: { rgb: 'C6E0B4' } },
    },
    box: {
        font: { sz: 10, name: 'Arial' },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: atkSaleBorder,
    },
    boxGrey: {
        font: { sz: 10, name: 'Arial' },
        alignment: { horizontal: 'center', vertical: 'center' },
        border: atkSaleBorder,
        fill: { fgColor: { rgb: 'D9D9D9' } },
    },
    dataText: {
        font: { sz: 10, name: 'Arial' },
        alignment: { vertical: 'center' },
    },
    dataNum: {
        font: { sz: 10, name: 'Arial' },
        alignment: { horizontal: 'right', vertical: 'center' },
        numFmt: atkSaleNumberFormat,
    },
};

const ExcelExport = forwardRef((params, ref) => {
    const [data, setData] = useState([])
    const [fileName, setFileName] = useState()
    const tableRef = useRef(null);

    const getData = (params) => {
        apiService().query('RptAtkPurchaseBook', params)
            .then((response) => {
                if (response.success) {
                    setData(response.data)
                    //params.data = response.data
                }
            })
    }

    const renderHeader = (headers) => {
        return headers.map((header, index) => {
            return header ? <th key={index} style={{ textAlign: 'left', fontSize: '9pt', fontFamily: 'Arial', backgroundColor: '#f0f0f0' }}>{header.columnName}</th> : 0
        });
    }

    const renderRow = (row) => {
        var headers = filterHeaders(params?.headers)
        return headers.map((header, index) => {
            return header ? <td key={index}>{row[header.name] ? row[header.name] : params?.zeroToNull === false ? row[header.key] : row[header.key] !== 0 ? row[header.key] : " "}</td> : 0
        });
    }

    const renderRows = function (rows) {
        return rows?.map((row, index) => {
            return <tr key={index} style={{ textAlign: 'center', fontSize: '9pt', fontFamily: 'Arial' }}>
                {renderRow(row)}
            </tr>
        })
    }

    const filterHeaders = (headers) => {
        return headers?.filter(h => h !== "");
    }

    const getExportValue = (row, header) => {
        let value = row?.[header.name] ? row[header.name] : row?.[header.key];

        if (value === undefined || value === null) {
            return '';
        }

        if (params?.zeroToNull !== false && value === 0) {
            return '';
        }

        if (header.type === 'number' && typeof value === 'string') {
            const parsed = parseFloat(value.replace(/,/g, ''));
            if (!isNaN(parsed)) {
                return parsed;
            }
        }

        return value;
    }

    const applyStyle = (worksheet, rowIndex, colIndex, style) => {
        const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
        if (!worksheet[cellRef]) {
            worksheet[cellRef] = { v: '', t: 's' };
        }
        worksheet[cellRef].s = style;
    }

    const buildAtkSaleWorksheet = () => {
        const columns = getAtkSaleExportColumns(params?.reference);
        const rows = [
            Array(columns.length).fill(''),
            Array(columns.length).fill(''),
            Array(columns.length).fill(''),
        ];

        rows[0][0] = 'Nr';
        rows[0][1] = 'Fatura';
        rows[0][3] = 'Blerësi';
        rows[0][6] = 'Shitjet e liruara nga TVSH';
        rows[0][12] = 'Shitjet e tatueshme me normën 18%';
        rows[0][18] = 'Shitjet e tatueshme me normën 8%';
        rows[0][23] = 'Totali i TVSH-se se zbritshme me 18% dhe 8%';

        columns.forEach((column, index) => {
            if (index > 0 && index < 23) {
                rows[1][index] = column.label;
            }
            if (index >= 6) {
                rows[2][index] = column.box || '';
            }
        });
        rows[2][0] = 'Numri i kutise ne deklaraten e TVSH-se';

        (params?.data || []).forEach((row) => {
            rows.push(columns.map(column => getExportValue(row, column)));
        });

        const worksheet = XLSX.utils.aoa_to_sheet(rows);
        worksheet['!merges'] = atkSaleMerges;
        worksheet['!cols'] = columns.map(column => ({ wch: column.width }));
        worksheet['!rows'] = [
            { hpt: 22 },
            { hpt: 62 },
            { hpt: 18 },
            ...Array.from({ length: Math.max(rows.length - 3, 0) }, () => ({ hpt: 18 })),
        ];

        for (let rowIndex = 0; rowIndex <= 2; rowIndex++) {
            for (let colIndex = 0; colIndex < columns.length; colIndex++) {
                applyStyle(worksheet, rowIndex, colIndex, atkSaleStyles.header);
            }
        }

        atkSaleGroupRanges.forEach(group => {
            for (let colIndex = group.start; colIndex <= group.end; colIndex++) {
                applyStyle(worksheet, 0, colIndex, atkSaleStyles.group);
            }
        });

        applyStyle(worksheet, 0, 0, atkSaleStyles.group);
        applyStyle(worksheet, 1, 0, atkSaleStyles.group);
        applyStyle(worksheet, 0, 23, atkSaleStyles.headerGrey);
        applyStyle(worksheet, 1, 23, atkSaleStyles.headerGrey);

        [17, 22].forEach(index => {
            applyStyle(worksheet, 1, index, atkSaleStyles.headerGreen);
        });

        applyStyle(worksheet, 2, 0, atkSaleStyles.boxGrey);
        for (let index = 1; index <= 5; index++) {
            applyStyle(worksheet, 2, index, atkSaleStyles.boxGrey);
        }

        columns.forEach((column, index) => {
            if (index >= 6) {
                const boxStyle = ['K10', 'K1', 'K2', 'K30'].includes(column.key) ? atkSaleStyles.boxGrey : atkSaleStyles.box;
                applyStyle(worksheet, 2, index, boxStyle);
            }
        });

        for (let rowIndex = 3; rowIndex < rows.length; rowIndex++) {
            columns.forEach((column, colIndex) => {
                const style = column.type === 'number' ? atkSaleStyles.dataNum : atkSaleStyles.dataText;
                applyStyle(worksheet, rowIndex, colIndex, style);
                const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
                if (column.type === 'number' && typeof worksheet[cellRef]?.v === 'number') {
                    worksheet[cellRef].z = atkSaleNumberFormat;
                }
            });
        }

        return worksheet;
    }

    const buildAtkPurchaseWorksheet = () => {
        const columns = getAtkPurchaseExportColumns();
        const rows = [
            Array(columns.length).fill(''),
            Array(columns.length).fill(''),
            Array(columns.length).fill(''),
        ];

        rows[0][0] = 'Nr';
        rows[0][1] = 'Fatura';
        rows[0][3] = 'Shitesi';
        rows[0][6] = 'Blerjet dhe importet e liruara dhe me TVSH jo te zbritshme';
        rows[0][10] = 'Blerjet dhe importet e tatueshme me 18%, si dhe rregullimet e zbritjeve';
        rows[0][19] = 'Blerjet dhe importet e tatueshme me 8%, si dhe rregullimet e zbritjeve';
        rows[0][28] = 'Totali i TVSH-se se zbritshme me 18% dhe 8%';

        columns.forEach((column, index) => {
            if (index > 0 && index < 28) {
                rows[1][index] = column.label;
            }
            if (index >= 6) {
                rows[2][index] = column.box || '';
            }
        });
        rows[2][0] = 'Numri i kutise ne deklaraten e TVSH-se';

        (params?.data || []).forEach((row) => {
            rows.push(columns.map(column => getExportValue(row, column)));
        });

        const worksheet = XLSX.utils.aoa_to_sheet(rows);
        worksheet['!merges'] = atkPurchaseMerges;
        worksheet['!cols'] = columns.map(column => ({ wch: column.width }));
        worksheet['!rows'] = [
            { hpt: 22 },
            { hpt: 72 },
            { hpt: 18 },
            ...Array.from({ length: Math.max(rows.length - 3, 0) }, () => ({ hpt: 18 })),
        ];

        for (let rowIndex = 0; rowIndex <= 2; rowIndex++) {
            for (let colIndex = 0; colIndex < columns.length; colIndex++) {
                applyStyle(worksheet, rowIndex, colIndex, atkSaleStyles.header);
            }
        }

        atkPurchaseGroupRanges.forEach(group => {
            for (let colIndex = group.start; colIndex <= group.end; colIndex++) {
                applyStyle(worksheet, 0, colIndex, atkSaleStyles.group);
            }
        });

        applyStyle(worksheet, 0, 0, atkSaleStyles.group);
        applyStyle(worksheet, 1, 0, atkSaleStyles.group);
        applyStyle(worksheet, 0, 28, atkSaleStyles.headerGrey);
        applyStyle(worksheet, 1, 28, atkSaleStyles.headerGrey);

        [18, 27].forEach(index => {
            applyStyle(worksheet, 1, index, atkSaleStyles.headerGreen);
        });

        applyStyle(worksheet, 2, 0, atkSaleStyles.boxGrey);
        for (let index = 1; index <= 5; index++) {
            applyStyle(worksheet, 2, index, atkSaleStyles.boxGrey);
        }

        columns.forEach((column, index) => {
            if (index >= 6) {
                const boxStyle = ['K1', 'K2', 'K67'].includes(column.key) ? atkSaleStyles.boxGrey : atkSaleStyles.box;
                applyStyle(worksheet, 2, index, boxStyle);
            }
        });

        for (let rowIndex = 3; rowIndex < rows.length; rowIndex++) {
            columns.forEach((column, colIndex) => {
                const style = column.type === 'number' ? atkSaleStyles.dataNum : atkSaleStyles.dataText;
                applyStyle(worksheet, rowIndex, colIndex, style);
                const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
                if (column.type === 'number' && typeof worksheet[cellRef]?.v === 'number') {
                    worksheet[cellRef].z = atkSaleNumberFormat;
                }
            });
        }

        return worksheet;
    }

    const setAutoWidths = (worksheet, headers = []) => {
        if (!worksheet?.['!ref']) {
            return;
        }

        const range = XLSX.utils.decode_range(worksheet['!ref']);
        worksheet['!cols'] = Array.from({ length: range.e.c - range.s.c + 1 }, (_, index) => {
            let maxLen = headers[index]?.columnName?.length || 10;

            for (let rowIndex = range.s.r; rowIndex <= range.e.r; rowIndex++) {
                const cell = worksheet[XLSX.utils.encode_cell({ r: rowIndex, c: index })];
                const value = cell?.w ?? cell?.v ?? '';
                const length = value ? value.toString().length : 0;

                if (length > maxLen) {
                    maxLen = length;
                }
            }

            return { wch: Math.min(Math.max(maxLen + 2, 10), 40) };
        });
    }

    useImperativeHandle(ref, () => ({

        exportToExcel(fileName) {
            if (params?.type === 'sale') {
                const worksheet = buildAtkSaleWorksheet();
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Raporti');
                XLSX.writeFile(workbook, (fileName || 'export') + '.xlsx');
                return;
            }

            if (params?.type === 'purchase') {
                const worksheet = buildAtkPurchaseWorksheet();
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Raporti');
                XLSX.writeFile(workbook, (fileName || 'export') + '.xlsx');
                return;
            }

            const isAtkBook = false;

            if (isAtkBook && tableRef.current) {
                const worksheet = XLSX.utils.table_to_sheet(tableRef.current);

                setAutoWidths(worksheet, filterHeaders(params?.headers));

                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Raporti');
                XLSX.writeFile(workbook, (fileName || 'export') + '.xlsx');
                return;
            }

            let headers = filterHeaders(params?.headers);
            let data = params?.data || [];

            const rows = [];

            // Header row
            rows.push(headers.map(h => h.columnName));

            // Data rows
            data.forEach(row => {
                rows.push(headers.map(h => {
                    let val = row[h.name] ? row[h.name] : row[h.key];
                    if (val === undefined || val === null) val = '';
                    // Convert formatted numbers back to real numbers
                    if (h.type === 'number' && typeof val === 'string') {
                        let parsed = parseFloat(val.replace(/,/g, ''));
                        if (!isNaN(parsed)) val = parsed;
                    }
                    return val;
                }));
            });

            const worksheet = XLSX.utils.aoa_to_sheet(rows);

            setAutoWidths(worksheet, headers);

            // Bold header row
            const range = XLSX.utils.decode_range(worksheet['!ref']);
            for (let c = range.s.c; c <= range.e.c; c++) {
                let cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: c })];
                if (cell) {
                    cell.s = { font: { bold: true }, fill: { fgColor: { rgb: "F0F0F0" } } };
                }
            }

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Raporti');
            XLSX.writeFile(workbook, (fileName || 'export') + '.xlsx');
        },

        exportToExcel1(fileName) {
            const printDiv = document.getElementById('print');
            if (!printDiv) {
                alert("Nuk u gjet elementi me id='print'");
                return;
            }

            const rows = [];

            // 1. Shtojmë kokën e majtë të kompanisë
            const leftInfo = printDiv.querySelector('div[style*="width: \'25%\'"]');
            if (leftInfo) {
                const lines = leftInfo.innerText.trim().split('\n');
                lines.forEach(line => rows.push([line]));
            }

            rows.push([]); // një rresht bosh

            // 2. Shtojmë titullin (Bilanci Provues)
            const title = printDiv.querySelector('h2');
            if (title) {
                rows.push([title.innerText]);
            }

            // 3. Shtojmë periudhën (nga div-i i djathtë)
            const rightInfo = printDiv.querySelector('div[style*="float: \\"right\\""]');
            if (rightInfo) {
                const periodLine = rightInfo.innerText.trim().split('\n');
                periodLine.forEach(line => rows.push([line]));
            }

            rows.push([]); // një rresht bosh

            // 4. Shtojmë përmbajtjen e tabelës
            const table = printDiv.querySelector('table');
            if (table) {
                const trs = table.querySelectorAll('tr');
                trs.forEach(tr => {
                    const tds = tr.querySelectorAll('td, th');
                    const row = [];
                    tds.forEach(td => row.push(td.innerText.trim()));
                    rows.push(row);
                });
            }

            rows.push([]); // një rresht bosh

            // 5. Shtojmë pjesën e fundit: përdoruesi dhe data
            const bottomInfo = printDiv.querySelectorAll('.col-6');
            bottomInfo.forEach(col => {
                rows.push([col.innerText.trim()]);
            });

            // 6. Ndërto Excel me SheetJS
            const worksheet = XLSX.utils.aoa_to_sheet(rows);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Raporti");

            XLSX.writeFile(workbook, `${fileName}.xlsx`);
        }

        // exportToExcel(type, fn, dl) {
        //     var elt = document.getElementById('print');
        //     var wb = XLSX.utils.table_to_book(elt, { sheet: "sheet1" });
        //     return dl ?
        //         XLSX.write(wb, { bookType: type, bookSST: true, type: 'base64' }) :
        //         XLSX.writeFile(wb, fn || ('MySheetName.' + (type || 'xlsx')));
        // }

        // exportToExcel1() {
        //     const elt = document.getElementById('table-to-xls-13') //document.getElementById('print') ? document.getElementById('print') : document.getElementById('table-to-xls-1');

        //     const wb = utils.table_to_book(elt);
        //     writeFileXLSX(wb, "SheetJSReactHTML.xlsx");
        // }

    }));



    useEffect(() => {
        let pm = params?.location?.search
        pm ? getData(pm.substring(1)) : setData(params?.data)
        if (pm) {
            getData(pm.substring(1))
            let fileName = (pm.split("&")[2]).split('=').pop() + "_" + (pm.split("&")[2]).split('=').pop() + "_" + (pm.split("&")[1]).split('=').pop();
            setFileName(fileName)
        }
        else {
            params.fileName ? setFileName(params.fileName) : 0
            setData(params?.data)
        }
    }, []);


    return (
        <div className={`p-5 ${params.hideContent ? 'd-none' : ''}`} style={{ overflowX: 'scroll' }}>
            <table id="table-to-xls-1" ref={tableRef}>
                {params?.type === 'purchase' && <AtkPurchaseBookHeader vat0={params?.vat0} vat18={params?.vat18} vat8={params?.vat8} />}
                {params?.type === 'sale' && <AtkSaleBookHeader vat0={params?.vat0} vat18={params?.vat18} vat8={params?.vat8} reference={params?.reference} />}
                {params?.type === 'other' && renderHeader(filterHeaders(params?.headers))}
                {renderRows(params?.data)}
            </table>
        </div>
    )
});

export default ExcelExport;
